import { GeoLocationResponse } from '~/types/geo-location'
import { countryData as countries } from '~/shared/constants/countryData.const'
import { countryData } from '~/shared/constants/locale.const'
import { getBrowserTimezone } from '~/utils/helpers'
import { i18nTimezones } from '~/utils/timezone'
import { homApi } from '~/redux/apis/hom'
import { CurriculumCountryCodes } from '~/curriculum/constants/curriculum.const'

export const geoLocationApi = homApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserLocationInfoFromIp: builder.query<Partial<GeoLocationResponse>, void>({
      query: () => '/v1/misc/geo-location',
      transformResponse({
        country,
        countryCode,
        curriculumCountryCode,
        currency,
        timezone,
        region,
      }: Partial<GeoLocationResponse>) {
        let _country
        let _countryCode
        let _curriculumCountryCode
        let _timezone

        if (country && countries.includes(country as (typeof countries)[number])) {
          _country = country
        }

        if (countryCode && countryData.map((elem) => elem.code).includes(countryCode)) {
          _countryCode = countryCode
        }

        if (
          curriculumCountryCode &&
          (Object.values(CurriculumCountryCodes) as string[]).includes(curriculumCountryCode)
        ) {
          _curriculumCountryCode = curriculumCountryCode
        }

        if (timezone && timezone in i18nTimezones) {
          _timezone = timezone
        } else {
          const browserTimezone = getBrowserTimezone()
          if (browserTimezone in i18nTimezones) {
            _timezone = browserTimezone
          }
        }

        return {
          country: _country,
          countryCode: _countryCode,
          curriculumCountryCode: _curriculumCountryCode,
          currency,
          timezone: _timezone,
          region,
        }
      },
    }),
  }),
})

export const { useGetUserLocationInfoFromIpQuery } = geoLocationApi
export const { useQueryState: useGetGeolocationQueryState } = geoLocationApi.endpoints.getUserLocationInfoFromIp
